import { CatalogDirectoryPage } from './catalog-pages.js'

export function ContentPage(): JSX.Element {
  return <CatalogDirectoryPage page="scenarios" />
}
